import { Component, Input } from '@angular/core';

@Component({
  selector: 'tun-more-vertical-icon',
  templateUrl: './more-vertical-icon.component.html',
  styleUrls: ['./more-vertical-icon.component.scss']
})
export class MoreVerticalIconComponent {

  @Input() color: string;

  constructor() { }

}
